"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAndInstall = void 0;
var common_sidecar_1 = require("@main/common-sidecar");
var voyageTestParams_sidecar_1 = require("@voyage/scene/voyageTestParams-sidecar");
// import { crokinoleUi_menu_gameEsc } from '@crokinole/ui-menus/crokinoleUi_menu_gameEsc-sidecar'
var perf2_sidecar_1 = require("@engine/perf2-sidecar");
// import { crokinoleGameState } from 'proto/crokinole/main/crokinoleGameState-sidecar'
var namespace = 'keys-minigolf';
// import { crokinoleTestParams } from '@crokinole/main/crokinoleTestParams-sidecar'
// import { crokinoleWebsockets } from '@crokinole/multi/crokinoleWebsockets-sidecar'
var genericKeyboard_1 = require("@crokinole/to-engine/genericKeyboard");
var minigolfMainGameGenerator_sidecar_1 = require("../simulation/minigolfMainGameGenerator-sidecar");
var minigolfGameState_sidecar_1 = require("../simulation/minigolfGameState-sidecar");
var createAndInstall = function () {
    var s = common_sidecar_1.common.getPhaserScene();
    console.log(namespace, 'create minigolf keyboard');
    genericKeyboard_1.addKey(['ShiftLeft', 'ShiftRight'], 'shift');
    genericKeyboard_1.addKey(['ControlLeft', 'ControlRight'], 'control');
    genericKeyboard_1.addKey(['AltLeft', 'AltRight'], 'alt');
    genericKeyboard_1.addKey(['KeyW', 'ArrowUp'], 'cameraUp');
    genericKeyboard_1.addKey(['KeyA', 'ArrowLeft'], 'cameraLeft');
    genericKeyboard_1.addKey(['KeyS', 'ArrowDown'], 'cameraDown');
    genericKeyboard_1.addKey(['KeyD', 'ArrowRight'], 'cameraRight');
    // ensureGameHandlesKey('Space')
    genericKeyboard_1.addHandler('Space', function () {
        // voyageGameManager.togglePause()
    });
    // ensureGameHandlesKey('ESC')
    genericKeyboard_1.addHandler('Escape', function () {
        // TODO: is crokinole running?
        // if(crokinoleUi_menu_main.isOpen('game-esc')) {
        //   crokinoleUi_menu_main.setOpen(false)
        // }
        // TODO: only if in game and crokinole running?
        // console.log('hit escape!!')
        // crokinoleUi_menu_gameEsc.toggleOpen()
    });
    // s.input.keyboard.addKey(34) // Pagedown
    genericKeyboard_1.addHandler('PageDown', function () {
        // diveSaver_all.write_toLocalStorage()
    });
    // s.input.keyboard.addKey(33) // Pagedown
    genericKeyboard_1.addHandler('PageUp', function () {
        // Read our saved data
        // if (diveSaver_all.read_fromLocalStorage()) {
        //   if (voyageWebsockets.getIsHost()) {
        //     // Tell everyone to reload too
        //     diveMultiUtilities_syncWorld.diveMulti_syncWorld()
        //   }
        // }
    });
    // s.input.keyboard.addKey('END')
    genericKeyboard_1.addHandler('End', function () {
        // if (crokinoleWebsockets.getIsHost()) {
        // l.forEach(diveCrew.getAll(), (c) => {
        //   if (c.type === EVoyageCrewType.Crew) {
        //     voyageMessageCrewHurt.sendMessageAndImmediatelyExecute({
        //       crewId: c.id,
        //       newHitpoints: -100,
        //       type: EVoyageCrewDamageType.Suicide,
        //       byCrewId: 0,
        //     })
        //     // diveCrew.makeDeadish(c, EVoyageCrewDamageType.Suicide) //'Suicide')
        //   }
        // })
        // }
    });
    // s.input.keyboard.addKey('HOME')
    genericKeyboard_1.addHandler('Home', function () {
        // if (crokinoleWebsockets.getIsHost()) {
        // console.log(namespace, 'Home, creating new world')
        // // Pause (TODO: move to host command?)
        // diveMessage_simulationSync.send(false)
        // diveMessage_hostCommand.sendMessageToAll({
        //   hostCommand: EDiveHostCommand.NewScenario,
        //   message: 'Creating new game...',
        // })
        // // TODO: implement this to create a whole noew world
        // voyageMessageHostCommand.sendMessageAndImmediatelyExecute({
        //   command: EHostCommand.NewScenario,
        // })
        // } else {
        //   // Try to join
        //   console.log(namespace, 'Home, joining channel')
        //   websockets.joinChannel('test', false, true, '')
        // }
    });
    // addHandler('KeyP', () => {
    //   crokinoleSounds.toggleSounds()
    // })
    // addHandler('KeyM', () => {
    //   crokinoleSounds.toggleMusic()
    // })
    genericKeyboard_1.addHandler(['KeyR'], function () {
        // crokinoleGameState.reset()
        console.log(namespace, 'signaling game reset');
        minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.signal_gameReset();
    });
    genericKeyboard_1.addHandler(['KeyN'], function () {
        // crokinoleGameState.reset()
        console.log(namespace, 'signaling new level');
        // Don't double-award food
        minigolfGameState_sidecar_1.minigolfGameState.get().playerState.food -=
            minigolfGameState_sidecar_1.minigolfGameState.get().playerState.levelPar;
        minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.signal_newLevel();
    });
    genericKeyboard_1.addHandler(['KeyP'], function () {
        // Cheat go to next level
        console.log(namespace, 'CHEATER signaling new level ++');
        // Don't double-award food
        minigolfGameState_sidecar_1.minigolfGameState.get().playerState.food -=
            minigolfGameState_sidecar_1.minigolfGameState.get().playerState.levelPar;
        minigolfGameState_sidecar_1.minigolfGameState.get().playerState.dungeonLevel++;
        minigolfGameState_sidecar_1.minigolfGameState.get().playerState.killedList += 'c';
        minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.signal_newLevel();
    });
    if (voyageTestParams_sidecar_1.voyageTestParams.isDevMode) {
        genericKeyboard_1.addHandler('Numpad1', function () {
            // crokinoleTestParams.setTestMode('normal')
        });
        genericKeyboard_1.addHandler('Numpad3', function () {
            //   crokinoleTestParams.setTestMode('game')
        });
        genericKeyboard_1.addHandler('Numpad6', function () {
            // crokinoleTestParams.setTestMode('mp-test')
        });
        genericKeyboard_1.addHandler('Numpad8', function () {
            // crokinoleTestParams.setTestMode('crokinole-main-menu')
        });
        genericKeyboard_1.addHandler('Numpad9', function () {
            // crokinoleTestParams.setTestMode('crokinole')
        });
        genericKeyboard_1.addHandler('Equal', function () {
            perf2_sidecar_1.perf2.report();
        });
    }
    genericKeyboard_1.installKeyboardHandler(namespace);
};
exports.createAndInstall = createAndInstall;
